export const GAME_CONFIG = {
  width: 480,
  height: 800,
  grid: {
    rows: 8,
    cols: 8,
    cellSize: 48,
    offsetX: 48,
    offsetY: 160,
  },
  piece: {
    previewY: 620,
    size: 48,
  },
  colors: {
    background: 0x3e2723,
    grid: 0x5d4037,
    gridLine: 0x4e342e,
    cellEmpty: 0x4e342e,
    pieces: [0xf44336, 0x2196f3, 0x4caf50, 0xffeb3b, 0x9c27b0, 0xff9800, 0x00bcd4],
  },
  scoring: {
    pointsPerLine: 100,
    cleanBoardMult: 5,
  },
};